var map = {
	"./Ali Khan.png": 176,
	"./Projects/P1.JPG": 65,
	"./Projects/P2.JPG": 726,
	"./Projects/P3.JPG": 267,
	"./Projects/anabeya.JPG": 725,
	"./Projects/chemistrylab.png": 400,
	"./Projects/doctorapp.JPG": 856,
	"./Projects/mrkhan.JPG": 517,
	"./Projects/nexsky.JPG": 504,
	"./Projects/snack.png": 217,
	"./Projects/userapp.JPG": 24,
	"./Three.js_Icon.svg.png": 531,
	"./next-js.svg": 7
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;